import { create } from 'zustand';
import { getReceiptStatus } from '@/services/receipts';

// Story 65.19 — a clínica tem o recebimento em partes ligado? A pergunta é feita uma vez por
// pessoa e clínica e a resposta fica guardada nesta aba. Enquanto não há resposta, ou se a
// pergunta falhar, vale "desligado": a tela fica como sempre foi.

const RETRY_AFTER_MS = 60_000;

interface ReceiptAvailabilityState {
  enabledBy: Record<string, boolean>;
  /** Story 65.22: a escrita nova está desligada, mas a clínica já tem o que ler e acertar. */
  readOnlyBy: Record<string, boolean>;
  askedAt: Record<string, number>;
  ensure: (key: string) => Promise<void>;
  reset: () => void;
}

export const useReceiptAvailability = create<ReceiptAvailabilityState>((set, get) => ({
  enabledBy: {},
  readOnlyBy: {},
  askedAt: {},
  ensure: async (key) => {
    const { enabledBy, askedAt } = get();
    if (key in enabledBy) return;
    if (askedAt[key] && Date.now() - askedAt[key] < RETRY_AFTER_MS) return;
    set((state) => ({ askedAt: { ...state.askedAt, [key]: Date.now() } }));
    try {
      const answer = await getReceiptStatus();
      set((state) => ({
        enabledBy: { ...state.enabledBy, [key]: answer.enabled === true },
        readOnlyBy: { ...state.readOnlyBy, [key]: answer.readOnly === true },
      }));
    } catch {
      // Sem resposta: segue desligado e pergunta de novo mais tarde.
    }
  },
  reset: () => set({ enabledBy: {}, readOnlyBy: {}, askedAt: {} }),
}));
